import React from 'react';
import { useTranslation } from 'react-i18next';
import Key from './key.webp';
import styles from './AdvantagesSection.module.scss';

interface AdvantageItem {
  icon: string;
  key: string;
}

const advantagesData: AdvantageItem[] = [
  {
    icon: 'https://cdn.jsdelivr.net/npm/bootstrap-icons@1.10.5/icons/link-45deg.svg',
    key: 'advantages.item1'
  },
  {
    icon: 'https://cdn.jsdelivr.net/npm/bootstrap-icons@1.10.5/icons/power.svg',
    key: 'advantages.item2'
  },
  {
    icon: 'https://cdn.jsdelivr.net/npm/bootstrap-icons@1.10.5/icons/key.svg',
    key: 'advantages.item3'
  },
  {
    icon: 'https://cdn.jsdelivr.net/npm/bootstrap-icons@1.10.5/icons/headset.svg',
    key: 'advantages.item4'
  },
  {
    icon: 'https://cdn.jsdelivr.net/npm/bootstrap-icons@1.10.5/icons/clock-history.svg',
    key: 'advantages.item5'
  },
  {
    icon: 'https://cdn.jsdelivr.net/npm/bootstrap-icons@1.10.5/icons/laptop.svg',
    key: 'advantages.item6'
  },
  {
    icon: 'https://cdn.jsdelivr.net/npm/bootstrap-icons@1.10.5/icons/lightning-charge.svg',
    key: 'advantages.item7'
  },
  {
    icon: 'https://cdn.jsdelivr.net/npm/bootstrap-icons@1.10.5/icons/person-plus-fill.svg',
    key: 'advantages.item8'
  }
];

const AdvantagesSection: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section className={styles.advantagesSection}>
      <h2 className={styles.title}>{t('advantages.title')}</h2>

      <div className={styles.contentWrapper}>
        <div className={styles.grid}>
          {advantagesData.map((item, index) => (
            <div className={styles.card} key={index}>
              <div className={styles.iconWrapper}>
                <img src={item.icon} alt="icon" loading="lazy" />
              </div>
              <p>{t(item.key)}</p>
            </div>
          ))}
        </div>

        <div className={styles.rightSide}>
          <img 
            src={Key} 
            alt={t('advantages.rightImageAlt')} 
            loading="lazy"
            width="1024"
            height="1024"
          />
        </div>
      </div>
    </section>
  );
};

export default AdvantagesSection;
